// Main exports for programmatic usage
export { kickstartCommand } from './commands/kickstart';
export type { PackageInfo } from './types'; 